import { LitElement, html, unsafeCSS } from 'lit';
import { customElement } from 'lit/decorators.js';
import { AtlBreadcrumbsProps as AtlBreadcrumbsProps } from './props.ts';
import { IClassMap } from '../helpers.ts';
import { classMap } from 'lit/directives/class-map.js';
import * as TagNames from './breadcrumbs.tagnames.ts';
import breadcrumbsStyles from './breadcrumbs.scss?inline';

@customElement(TagNames.BreadCrumbs)
export class AtlBreadcrumbs extends LitElement implements AtlBreadcrumbsProps {
   declare internalId: string;
   declare internalClassName?: string;
   declare marginTop?: boolean;

   static properties = {
      internalId: { type: String },
      internalClassName: { type: String },
      marginTop: { type: Boolean },
   };

   static styles = [
      unsafeCSS(breadcrumbsStyles)
   ];

    render() {
        const classNames: IClassMap = {
            breadcrumbs: true,
            'top-content': this.marginTop === true,
        };
        if (this.internalClassName) {
            classNames[this.internalClassName] = true;
        }

        return html`
        <nav
            id=${this.internalId}
            aria-label="breadcrumb"
            class=${classMap(classNames)}
            part="nav"
        >
            <div class="breadcrumb" part="breadcrumb">
                <slot></slot>
            </div>
        </nav>
    `;

    }
}
